import fetcher from '../utils/api';

const scribeFileService = {
  getScribeFile: async ({ id, authenticated = true, includeActionsCount = false }) => {
    const additionalParams = [];

    if (includeActionsCount) {
      additionalParams.push(`include_actions_count=1`);
    }

    return fetcher(`scribe_file/${id}/${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', authenticated);
  },
  getOutline: async (id, omitComments) => {
    return fetcher(`scribe_file/${id}/outline/${omitComments ? '?omit_comments=true' : ''}`, 'GET', true);
  },
  getDocumentEstimatedTime: async (id) => {
    return fetcher(`scribe_documents/${id}/duration/`, 'GET', true);
  },
  deleteAction: async (id) => fetcher(`actions/${id}/`, 'DELETE', true),
  addAction: async (id, kind, instructionType, addAfterActionId, externalScreenshotUrl) =>
    fetcher(`scribe_documents/${id}/add_action`, 'POST', true, {
      kind,
      add_after_action_id: addAfterActionId,
      instruction_type: instructionType,
      external_screenshot_url: externalScreenshotUrl
    }),
  updateAction: async (id, newActionBody) => fetcher(`actions/${id}/`, 'PUT', true, newActionBody),
  deleteMultipleActions: async (id, actionsToDelete) =>
    fetcher(`scribe_documents/${id}/delete_actions`, 'DELETE', true, {
      actions_to_delete: actionsToDelete
    }),
  updateScribeFile: async (id, data) => fetcher(`scribe_file/${id}/`, 'PATCH', true, data),
  stackSelectedActions: async (id, actionIdsToStack) =>
    fetcher(`scribe_documents/${id}/stacks`, 'POST', true, {
      ...(actionIdsToStack
        ? {
            action_ids: actionIdsToStack
          }
        : {})
    }),
  updateStack: async (stackId, actionIdsToStack) =>
    fetcher(`stacks/${stackId}/`, 'PATCH', true, {
      action_ids: actionIdsToStack
    }),
  deleteStack: async (stackId) => fetcher(`stacks/${stackId}/`, 'DELETE', true),
  deleteAutoStackedActions: async (documentId) => fetcher(`scribe_documents/${documentId}/stacks`, 'DELETE', true),
  fetchAction: async (actionId) => fetcher(`actions/${actionId}/`, 'GET', true),
  getExportedDocumentForScribeFile: async (id, format) =>
    fetcher(`scribe_documents/${id}/document_export?export_format=${format}`, 'GET', true, {}),
  changeUserPermission: async (id, userId, permissionLevel) =>
    fetcher(`permissions/user_object_permission/document_metadata/${id}/`, 'PUT', true, {
      user: userId,
      permission_level: permissionLevel
    }),
  changeCandidatePermission: async (id, email, permissionLevel) =>
    fetcher(`permissions/candidate_scribe_document_permission/${id}/`, 'PUT', true, {
      email,
      permission_level: permissionLevel
    }),
  getUsersWithPermission: async (id) => fetcher(`permissions/user_object_permission/document_metadata/${id}/`, 'GET', true),
  getCandidatesWithPermission: async (id) => fetcher(`permissions/candidate_scribe_document_permission/${id}/`, 'GET', true),
  requestAccess: async (id) => fetcher(`scribe_documents/${id}/request_access/`, 'POST', true),
  requestSuperOrganizationSSOInformation: async (id) => fetcher(`document_metadata/${id}/super_organization_info/`, 'GET', false),
  getActionsSortOrder: async (id, fromActionId, toActionId) => {
    const additionalParams = [];

    if (fromActionId) {
      additionalParams.push(`from_action_id=${fromActionId}`);
    }
    if (toActionId) {
      additionalParams.push(`to_action_id=${toActionId}`);
    }

    return fetcher(
      `scribe_documents/${id}/action_sort_order` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`,
      'GET',
      true
    );
  },
  updateDocumentMetadata: async ({ id, bodyParams }) => {
    return fetcher(`scribe_file/${id}/document_metadata/`, 'PATCH', true, bodyParams);
  },
  giveFeedback: async (id, feedbackChoices, otherFeedback) => {
    return fetcher(`document_feedback/?doc_id=${id}`, 'POST', true, {
      feedback_choices: feedbackChoices,
      other_feedback: otherFeedback
    });
  },
  getFeedbackForDoc: async (id) => {
    return fetcher(`document_feedback/?doc_id=${id}`, 'GET', true);
  },
  updateFeedback: async (feedbackId, bodyParams) => {
    return fetcher(`document_feedback/${feedbackId}/`, 'PATCH', true, bodyParams);
  },
  deleteFeedback: async (feedbackId) => {
    return fetcher(`document_feedback/${feedbackId}/`, 'DELETE', true);
  }
};

export default scribeFileService;
